module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/二维码.ef959.png";